import Vue from "vue";
import Router from "vue-router";
import NotAllowed from "@/components/core/NotAllowed.vue";
import Login from "@/components/core/Login.vue";
import Perfil from "@/components/core/Perfil.vue";
import Landing from "@/components/core/Landing.vue";
import Dashboard from "../components/core/DashBoard/Dashboard.vue";
import GraphicsMenu from "@/components/graficas/GraphicsMenu.vue";
import Graficas from "@/components/graficas/Graficas.vue";
import GraphByCompany from "@/components/graficas/GraphByCompany.vue";
import Guides from "@/components/informes/Guides.vue";
import View from "@/components/informes/View.vue";
import Viewshare from "@/components/informes/Viewshare.vue";
import DataMenu from "@/components/data/DataMenu.vue";
import Listview from "@/components/informes/Listview.vue";
import UploadDataFrs from "@/components/data/UploadDataFrsV2.vue";
import UploadData from "@/components/data/UploadData.vue";
import SelectUpload from "@/components/data/SelectUpload.vue";
import ListData from "@/components/data/ListData.vue";
import Logs from "@/components/logs/Logs.vue";
// import ReportsMenu from "@/components/informes/ReportsMenu.vue";
import Creainforme from "@/components/informes/Crea.vue";
import Listplantilla from "@/components/informes/Listplantilla.vue";
import Carpetalist from "@/components/informes/Listinformes1.vue";
import Lideres from "@/components/lideres/Lideres.vue";
import EncuestaLider from "@/components/lideres/EncuestaLider.vue";
import Finencuesta from "@/components/lideres/Survey/EndSurvey.vue";
import CloseSurvey from "@/components/lideres/Survey/CloseSurvey.vue";
// import Subirlideres from '@/components/lideres/Subirlideres.vue';
import Listfrs from "@/components/frs/Listfrs.vue";
import Vfrs from "@/components/frs/Vfrs.vue";
import Priorization from "@/components/frs/Priorizationfrs.vue";
import Lider from "@/components/lideres/Liderv1.vue";
import ResultLider from "@/components/lideres/ResultLider.vue";
import ShareLideres from "@/components/lideres/ShareLideres.vue";
import Evaluado from "@/components/lideres/Evaluado.vue";
import Estadisticos from "@/components/estadisticos/Estadisticos.vue";
import DataEditor from "@/components/data/DataEditor.vue";
import EncuestaClima from "@/components/clima/EncuestaClima.vue";
import FinEncuestaClima from "@/components/clima/FinEncuestaClima.vue";

import Logout from "@/components/core/Logout.vue";

// Clima
// import Clima from "@/components/clima/Clima.vue";
import Landingclima from "@/components/landingclima/Landingclima.vue";
import Personalinformation from "@/components/clima/menuclima/Personalinformation.vue";
import Companyinformation from "@/components/clima/menuclima/Companyinformation.vue";
import Loaddata from "@/components/clima/menuclima/Loaddata.vue";
import Statussurverys from "@/components/clima/menuclima/Statussurveys.vue";
import Results from "@/components/clima/menuclima/Results.vue";
import Menuclima from "@/components/climan/Menuclima.vue";
import Accessclima from "@/components/climan/AccessEncuesta.vue";
import ViewClima from "@/components/climan/ViewClima.vue";
import HomeClima from "@/components/climan/HomeClima.vue";

// Cultura
// OLD import Menucultura from "@/components/cultura/Menucultura.vue";
// OLD import Encuestacultura from "@/components/cultura/Encuestacultura.vue";
// OLD import Accesscultura from "@/components/cultura/AccessEncuestacultura.vue";
// OLD import ResultadoCompartidoCultura from "@/components/cultura/ResultadoCompartido.vue";
import routesCultura from "@/components/cultura/routes.js";
import routesUsers from "@/components/users/routes.js";
import routesEmpresas from "@/components/empresas/routes.js";
import routesSettings from "@/components/settings/routes.js";

// Frsm
import MenuFrs from "../components/frpm/MenuFrs.vue";
import ResultadoCompartidoFrp from "../components/frpm/ResultadoCompartido.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: (to) => {
      return {
        name: "dashboard", // landing
        meta: {
          isPublic: true,
        },
      };
    },
  },
  {
    path: "/landing",
    name: "landing",
    component: Landing,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/landingclima",
    name: "landingclima",
    component: Landingclima,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/dashboard",
    component: Dashboard,
    name: "dashboard",
    menu: {
      section: "Inicio",
      icon: "dashboard",
      title: "Dashboard",
      scope: ["admin", "cliente"],
    },
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/main-report",
    component: View,
    name: "home",
    /* menu: {
      section: "Inicio",
      icon: "web",
      title: "Informe",
      scope: ["admin", "cliente"],
    }, */
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/btn",
    name: "Pdf",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/listview",
    component: Listview,
    name: "listview",
    menu: {
      section: "Inicio",
      icon: "list",
      title: "Informes",
      scope: ["admin", "cliente"],
    },
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/listview/:id",
    component: View,
    name: "listviewid",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/listview/crea",
    component: Creainforme,
    scope: ["admin", "cliente"],
    name: "listview.crea",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/listview/carpetaslist",
    component: Carpetalist,
    name: "listview.carpetaslist",
    scope: ["admin", "cliente"],
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/listview/plantillalist",
    component: Listplantilla,
    name: "listview.plantillalist",
    scope: ["admin", "cliente"],
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/listview/guides",
    component: Guides,
    name: "listview.guides",
    scope: ["admin"],
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/share/:id",
    component: Viewshare,
    name: "shareid",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/sharelider/:relacionid/:liderid/:procesoid",
    component: ResultLider,
    name: "sharelider",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/lideres/share/:id/:filter",
    component: ShareLideres,
    name: "sharelideres",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/notAllowed",
    component: NotAllowed,
    name: "notAllowed",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      isPublic: true,
      isAuthenticated: false,
    },
  },
  {
    path: "/perfil",
    name: "perfil",
    component: Perfil,
    meta: {
      isAuthenticated: true,
    },
  },
  ...routesEmpresas,
  {
    path: "/datamenu",
    component: DataMenu,
    name: "datamenu",
    menu: {
      section: "Admin",
      icon: "list",
      title: "Datos",
      scope: ["admin", "cliente"],
    },
    meta: {
      isAuthenticated: true,
    },
    children: [
      {
        path: "/datamenu/uploaddata",
        component: SelectUpload,
        scope: ["admin"],
        name: "datamenu.uploaddata",
        meta: {
          isAuthenticated: true,
        },
      },
      {
        path: "/datamenu/listfrs",
        component: Listfrs,
        name: "datamenu.listfrs",
        scope: ["admin"],
        meta: {
          isAuthenticated: true,
        },
      },
      {
        path: "/datamenu/listdata",
        component: ListData,
        name: "datamenu.listdata",
        scope: ["admin", "cliente"],
        meta: {
          isAuthenticated: true,
        },
      },
    ],
  },
  {
    path: "/uploaddata/frs",
    component: UploadDataFrs,
    name: "uploaddatafrs",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/uploaddata/otros",
    component: UploadData,
    name: "uploaddataotros",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/listfrs/:id",
    component: Vfrs,
    name: "listviewfrsid",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/priorization/:id",
    component: Priorization,
    name: "priorizationfrsid",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/graphicsmenu",
    component: GraphicsMenu,
    name: "graphicsmenu",
    menu: {
      section: "Admin",
      icon: "assessment",
      title: "Gráficas",
      scope: ["admin", "cliente"],
    },
    meta: {
      isAuthenticated: true,
    },
    children: [
      {
        path: "/graphicsmenu/graphics",
        component: Graficas,
        scope: ["admin", "cliente"],
        name: "graphicsmenu.graphics",
        meta: {
          isAuthenticated: true,
        },
      },
      {
        path: "/graphicsmenu/graphbycompany",
        component: GraphByCompany,
        name: "graphicsmenu.graphbycompany",
        scope: ["admin", "cliente"],
        meta: {
          isAuthenticated: true,
        },
      },
    ],
  },
  // ,
  // {
  //   path: "/reportsmenu",
  //   component: ReportsMenu,
  //   name: "reportsmenu",
  //   menu: {
  //     section: "Admin",
  //     icon: "description",
  //     title: "Informes",
  //     scope: ["admin", "cliente"],
  //   },
  //   meta: {
  //     isAuthenticated: true,
  //   },
  //   children: [
  //     {
  //       path: "/reportsmenu/crea",
  //       component: Creainforme,
  //       scope: ["admin", "cliente"],
  //       name: "reportsmenu.crea",
  //       meta: {
  //         isAuthenticated: true,
  //       },
  //     },
  //     {
  //       path: "/reportsmenu/carpetaslist",
  //       component: Carpetalist,
  //       name: "reportsmenu.carpetaslist",
  //       scope: ["admin", "cliente"],
  //       meta: {
  //         isAuthenticated: true,
  //       },
  //     },
  //     {
  //       path: "/reportsmenu/plantillalist",
  //       component: Listplantilla,
  //       name: "reportsmenu.plantillalist",
  //       scope: ["admin", "cliente"],
  //       meta: {
  //         isAuthenticated: true,
  //       },
  //     },
  //     {
  //       path: "/reportsmenu/guides",
  //       component: Guides,
  //       name: "reportsmenu.guides",
  //       scope: ["admin"],
  //       meta: {
  //         isAuthenticated: true,
  //       },
  //     },
  //   ],
  // }
  {
    path: "/plantillalist/:tipo/:id",
    component: Creainforme,
    name: "editinforme",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/carpetaslist/:tipo/:id",
    component: Creainforme,
    name: "editinforme1",
    meta: {
      isAuthenticated: true,
    },
  },
  ...routesUsers,
  {
    path: "/logs",
    component: Logs,
    name: "logs",
    menu: {
      section: "Admin",
      icon: "assignment",
      title: "Registros",
      scope: ["admin"],
    },
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
    meta: {
      isAuthenticated: true,
    },
  },
  {
    // Factores de riesgo
    path: "/frp",
    component: MenuFrs,
    name: "frp",
    menu: {
      section: "Factores de riesgo",
      icon: "blur_on",
      title: "FRP",
      scope: ["admin", "frp"],
    },
    meta: {
      isAuthenticated: true,
    },
  },
  {
    // Factores de riesgo - Tablero compartido
    path: "/frp/share/:id/:filter",
    component: ResultadoCompartidoFrp,
    name: "frp compartido",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/verlideres/:id",
    name: "verlideres",
    component: Lideres,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/lider",
    component: Lider,
    menu: {
      section: "Liderazgo",
      icon: "stars",
      title: "Líderes PhD",
      scope: ["admin", "lider", "ghumana"],
    },
    name: "lider",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/liderl",
    component: Evaluado,
    menu: {
      section: "Liderazgo",
      icon: "stars",
      title: "Resultados",
      scope: ["liderl"],
    },
    name: "liderl",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/encuesta/fin",
    name: "finencuesta",
    component: Finencuesta,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/encuesta/close",
    name: "closeSurvey",
    component: CloseSurvey,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/encuesta/:id",
    name: "encuestalider",
    component: EncuestaLider,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/resultlider/:procesoid/:liderid",
    name: "resultlider",
    component: ResultLider,
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/estadisticos/:procesoid",
    name: "estadisticos",
    component: Estadisticos,
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/dataeditor/:id",
    name: "dataeditor",
    component: DataEditor,
    meta: {
      isAuthenticated: true,
    },
  },
  // {
  //   path: "/clima",
  //   component: Clima,
  //   menu: {
  //     section: "Clima",
  //     icon: "ac_unit",
  //     title: "Clima",
  //     scope: ["free", "admin"],
  //   },
  //   name: "clima",
  //   meta: {
  //     isAuthenticated: true,
  //   },
  // },
  {
    path: "/clima7/home",
    component: HomeClima,
    menu: {
      section: "Clima",
      icon: "ac_unit",
      title: "Clima Cl7",
      scope: ["free"],
    },
    name: "HomeClima",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/clima/personalinformation",
    component: Personalinformation,
    scope: ["free", "admin"],
    name: "clima.personalinformation",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/clima/companiinformation",
    component: Companyinformation,
    scope: ["free", "admin"],
    name: "clima.companyinformation",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/clima/loaddata",
    component: Loaddata,
    scope: ["free", "admin"],
    name: "clima.loaddata",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/clima/statussurveys",
    component: Statussurverys,
    scope: ["free", "admin"],
    name: "clima.statussurveys",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/clima/results",
    component: Results,
    scope: ["free", "admin"],
    name: "clima.results",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/shareClima/:id/:filter",
    component: ViewClima,
    name: "clima.viewClima",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/encuestaclima/:id",
    name: "encuestaclima",
    component: EncuestaClima,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/encuestaclima/fin",
    name: "finencuestaclima",
    component: FinEncuestaClima,
    meta: {
      isPublic: true,
    },
  },
  // {
  //   path: "/chartclima",
  //   component: Chartclima,
  //   menu: {
  //     section: "Clima",
  //     icon: "assessment",
  //     title: "Graficas",
  //     scope: ["admin"],
  //   },
  //   name: "chartclima",
  //   meta: {
  //     isAuthenticated: true,
  //   },
  // },
  {
    path: "/climan",
    component: Menuclima,
    menu: {
      section: "Clima",
      icon: "ac_unit",
      title: "Clima",
      scope: ["admin"],
    },
    name: "climan",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/accesoclima/:codigo",
    name: "accesoclima",
    component: Accessclima,
    meta: {
      isPublic: true,
    },
  },
  ...routesCultura,
  ...routesSettings,
  /* {
    path: "/cultura",
    component: Menucultura,
    menu: {
      section: "Cultura",
      icon: "stream",
      title: "Cultura",
      scope: ["admin"],
    },
    name: "cultura",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/cultura/share/:id/:filter",
    component: ResultadoCompartidoCultura,
    name: "Cultura compartido",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/encuestacultura/:id",
    name: "encuestacultura",
    component: Encuestacultura,
    meta: {
      isPublic: true,
    },
  }, 
  {
    path: "/accesocultura/:codigo",
    name: "accesocultura",
    component: Accesscultura,
    meta: {
      isPublic: true,
    },
  }, */
  // Default
  {
    path: "*",
    redirect: "/dashboard",
  },
];

const router = new Router({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  let loggedin = localStorage.getItem("loggedin");
  loggedin = JSON.parse(loggedin);
  if (to.matched.some((record) => record.meta.isAuthenticated)) {
    if (!loggedin) {
      console.log("se va para login");
      next("login");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/routes/index.js